import { createAsyncThunk } from "@reduxjs/toolkit";
import { userId } from "src/helpers/user_id";
import { apiClient } from '../../helpers/api_helper';

/*
export const getPhases: any = createAsyncThunk("phases/getPhases", async () => {
  try {
    const response = await apiClient.get(`/phase/phases/`);
    return response;
  } catch (error) {
    return error;
  }
});
*/
export const addPhase = createAsyncThunk("phases/addPhase", async (phase: any) => {
    try {
      const response = await apiClient.post(`/phase/phases/`,{
          nome: phase.nome,
          projecto: phase.projecto,
          create_user: userId,
          update_user: userId,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updatePhase = createAsyncThunk("phases/updatePhase", async (phase: any) => {
    try {
      const response = await apiClient.put(`/phase/phases/${phase.id}/`,{
          nome: phase.nome,
          projecto: phase.projecto,
          create_user: userId,
          update_user: userId,
        });
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deletePhase = createAsyncThunk("phases/deletePhase", async (phaseId: any) => {
    try {
      const response = await apiClient.delete(`/phase/phases/${phaseId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);
